export default __webpack_public_path__ + "static/media/cart.d1bd8517.svg";